export const modelInfo = {
  'gpt-6-astra': {
    name: 'OpenAI GPT-6 Astra',
    description:
      "OpenAI's most capable model, designed for the hardest end-to-end work. Supports Responses API and Chat Completions with streaming, structured outputs, function calling, and Responses hosted tools. Reasoning effort configurable (low/medium/high/xhigh/max).",
    strengths: [
      'Most capable OpenAI model for complex end-to-end tasks',
      '1M+ token context window with 128K max output',
      'Configurable reasoning effort (low through max)',
      'Full tool support: function calling, structured outputs, hosted tools',
    ],
    limitations: [
      'Premium pricing ($10 / $50 per MTok; $1 cached input)',
      'Higher latency at elevated reasoning effort levels',
    ],
    parameters: {
      contextWindow: 1_050_000,
      modelSize: 'XL',
      maxTokens: 128_000,
      trainingData: 'Not disclosed',
      modalities: ['text', 'image'],
      toolUse: true,
    },
    link: 'https://developers.openai.com/api/docs/models/gpt-6-astra',
  },
  'gpt-6.1-sol': {
    name: 'OpenAI GPT-6.1 Sol',
    description:
      "OpenAI's newest general-purpose model (GA Sep 29, 2026) — near-Astra capability at lower cost, built for complex coding, computer use, and professional work. Routes through the Responses API.",
    strengths: [
      'Near-Astra performance at lower cost',
      'Complex coding, computer use, and professional work',
      '1M+ token context window',
      'Responses API with tool use',
    ],
    limitations: [
      'Still premium-priced ($2 / $10 per MTok)',
      'Knowledge cutoff excludes very recent events',
    ],
    parameters: {
      contextWindow: 1_050_000,
      modelSize: 'XL',
      maxTokens: 128_000,
      trainingData: 'Not disclosed',
      modalities: ['text', 'image'],
      toolUse: true,
    },
    link: 'https://developers.openai.com/api/docs/models/gpt-6.1-sol',
  },
  'gpt-5.6-sol': {
    name: 'OpenAI GPT-5.6 Sol',
    description:
      "OpenAI's frontier flagship (GA July 9, 2026) for the hardest problems — complex coding across large codebases, multi-step agents, scientific reasoning, and defensive security research.",
    strengths: [
      'Frontier reasoning and long-horizon agentic work',
      'State-of-the-art software engineering performance',
      '1M+ token context window',
      'Best-in-class on complex multi-step problems',
    ],
    limitations: [
      'Highest cost in GPT-5.6 family ($5 / $30 per MTok)',
      'Higher latency than Terra/Luna',
      'Programmatic tool calling requires Responses API (Chat Completions works but with fewer features)',
    ],
    parameters: {
      contextWindow: 1_050_000,
      modelSize: 'XL',
      maxTokens: 128_000,
      trainingData: 'May 2026',
      modalities: ['text', 'image'],
      toolUse: true,
    },
    link: 'https://openai.com/index/gpt-5-6/',
    legacy: true,
  },
  'gpt-5.6-terra': {
    name: 'OpenAI GPT-5.6 Terra',
    description:
      'Balanced production workhorse — matches GPT-5.5 performance at roughly 2× lower cost. Ideal for customer support, internal tools, and document analysis. GA July 9, 2026.',
    strengths: [
      'Competitive with GPT-5.5 at half the price',
      'Excellent for high-volume business workloads',
      'Strong tool use and structured output',
      '1M+ token context window',
    ],
    limitations: ['Less depth than Sol on the hardest problems'],
    parameters: {
      contextWindow: 1_050_000,
      modelSize: 'L',
      maxTokens: 128_000,
      trainingData: 'May 2026',
      modalities: ['text', 'image'],
      toolUse: true,
    },
    link: 'https://openai.com/index/gpt-5-6/',
    legacy: true,
  },
  'gpt-5.6-luna': {
    name: 'OpenAI GPT-5.6 Luna',
    description:
      "OpenAI's fastest and cheapest GPT-5.6 — built for high-volume tasks like summarization and drafting. GA July 9, 2026.",
    strengths: [
      'Lowest cost in GPT-5.6 family ($1 / $6 per MTok)',
      'Very low latency for high-throughput tasks',
      'Strong capability at budget tier',
      '1M+ token context window',
    ],
    limitations: [
      'Limited reasoning depth vs Sol/Terra',
      'Not ideal for complex multi-step tasks',
    ],
    parameters: {
      contextWindow: 1_050_000,
      modelSize: 'M',
      maxTokens: 128_000,
      trainingData: 'May 2026',
      modalities: ['text', 'image'],
      toolUse: true,
    },
    link: 'https://openai.com/index/gpt-5-6/',
    legacy: true,
  },
  'gpt-5.5': {
    name: 'OpenAI GPT-5.5',
    description:
      "OpenAI's smartest and most intuitive flagship — best for complex reasoning, coding, research, and data analysis across tools.",
    strengths: [
      'State-of-the-art reasoning and coding',
      'Reduced hallucinations vs GPT-5.4',
      'Improved personalization controls',
      'Frontier multimodal understanding',
    ],
    limitations: [
      'Higher cost than mini/nano variants',
      'Higher latency than mini/nano variants',
      'Knowledge cutoff excludes very recent events',
    ],
    parameters: {
      contextWindow: 500_000,
      modelSize: 'XL',
      maxTokens: 128_000,
      trainingData: 'April 2026',
      modalities: ['text', 'image'],
      toolUse: true,
    },
    link: 'https://openai.com/index/introducing-gpt-5-5/',
    legacy: true,
  },
  'gpt-5.5-pro': {
    name: 'OpenAI GPT-5.5 Pro',
    description:
      'Professional-tier GPT-5.5 that uses more compute to think harder for smarter, more precise responses on the most complex tasks. Routes through the OpenAI Responses API.',
    strengths: [
      'Maximum reasoning depth in GPT-5.5 family',
      'Best for long-horizon agentic tasks',
      'Consistently better answers via extra compute',
      'Advanced structured output and tool orchestration',
    ],
    limitations: [
      'Highest cost in GPT-5.5 family',
      'Slower inference due to extra compute',
      'Overkill for simple tasks',
    ],
    parameters: {
      contextWindow: 500_000,
      modelSize: 'XL',
      maxTokens: 128_000,
      trainingData: 'April 2026',
      modalities: ['text', 'image'],
      toolUse: true,
    },
    link: 'https://developers.openai.com/api/docs/models/gpt-5.5-pro',
    legacy: true,
  },
  'gpt-5.4': {
    name: 'OpenAI GPT-5.4',
    description:
      'Previous flagship OpenAI model with enhanced reasoning, coding, and multimodal capabilities. Superseded by GPT-5.5.',
    strengths: [
      'State-of-the-art reasoning and coding',
      'Improved multimodal understanding',
      'Enhanced tool use reliability',
      'Best benchmark performance in GPT-5 family',
    ],
    limitations: [
      'Higher cost than previous versions',
      'Higher latency than mini/nano variants',
      'Knowledge cutoff excludes very recent events',
    ],
    parameters: {
      contextWindow: 500_000,
      modelSize: 'XL',
      maxTokens: 128_000,
      trainingData: 'January 2026',
      modalities: ['text', 'image'],
      toolUse: true,
    },
    link: 'https://platform.openai.com/docs/models',
    legacy: true,
  },
  'gpt-5.4-pro': {
    name: 'OpenAI GPT-5.4 Pro',
    description:
      'Previous professional-tier GPT-5.4 for complex enterprise and agentic workloads. Superseded by GPT-5.5 Pro.',
    strengths: [
      'Maximum reasoning and accuracy',
      'Best for long-horizon agentic tasks',
      'Advanced structured output support',
      'Premium tool orchestration',
    ],
    limitations: [
      'Highest cost in GPT-5.4 family',
      'Slower inference',
      'Overkill for simple tasks',
    ],
    parameters: {
      contextWindow: 500_000,
      modelSize: 'XL',
      maxTokens: 128_000,
      trainingData: 'January 2026',
      modalities: ['text', 'image'],
      toolUse: true,
    },
    link: 'https://platform.openai.com/docs/models',
    legacy: true,
  },
  'gpt-5.4-mini': {
    name: 'OpenAI GPT-5.4 Mini',
    description:
      'Balanced cost/speed variant of GPT-5.4 for everyday agent and chat tasks.',
    strengths: [
      'Fast responses at lower cost',
      'Strong coding and function-calling',
      'Reliable tool orchestration',
      'Good balance of speed and capability',
    ],
    limitations: [
      'Less depth than flagship GPT-5.4',
      'Lower reasoning ceiling',
    ],
    parameters: {
      contextWindow: 200_000,
      modelSize: 'M',
      maxTokens: 32_000,
      trainingData: 'January 2026',
      modalities: ['text', 'image'],
      toolUse: true,
    },
    link: 'https://platform.openai.com/docs/models',
    legacy: true,
  },
  'gpt-5.4-nano': {
    name: 'OpenAI GPT-5.4 Nano',
    description:
      'Ultra-fast, ultra-cheap GPT-5.4 variant for routing, classification, and simple flows.',
    strengths: [
      'Very low latency and cost',
      'Great for quick classification and routing',
      'Stable tool/function calling for simple agents',
    ],
    limitations: [
      'Limited reasoning depth',
      'Not ideal for complex multi-hop tasks',
    ],
    parameters: {
      contextWindow: 64_000,
      modelSize: 'S',
      maxTokens: 8_000,
      trainingData: 'January 2026',
      modalities: ['text'],
      toolUse: true,
    },
    link: 'https://platform.openai.com/docs/models',
    legacy: true,
  },
  'gpt-5.3-codex': {
    name: 'OpenAI GPT-5.3-Codex',
    description:
      'Most capable agentic coding model, pairing frontier coding performance with general reasoning for long-horizon technical work.',
    strengths: [
      'State-of-the-art on SWE-Bench Pro (4 languages)',
      'Interactive steering while working',
      '25% faster than GPT-5.2-Codex',
      'Research, tool use, and complex execution',
    ],
    limitations: [
      'Optimized for coding tasks',
      'Higher cost than standard models',
      'May be overkill for simple queries',
    ],
    parameters: {
      contextWindow: 256_000,
      modelSize: 'XL',
      maxTokens: 128_000,
      trainingData: 'January 2026',
      modalities: ['text', 'image'],
      toolUse: true,
    },
    link: 'https://openai.com/index/introducing-gpt-5-3-codex/',
    legacy: true,
  },
  // 'gpt-5.3-codex-spark': not yet available in OpenAI API
  'gpt-5.2': {
    name: 'OpenAI GPT-5.2',
    description:
      'Advanced iteration of GPT-5 with enhanced reasoning, improved cost efficiency, and expanded capabilities.',
    strengths: [
      'Superior reasoning and coding capabilities',
      'Cost-effective compared to GPT-5',
      'Expanded 500k context window',
      'Improved tool use and reliability',
    ],
    limitations: [
      'Higher latency than mini models',
      'Knowledge cutoff excludes very recent events',
    ],
    parameters: {
      contextWindow: 500_000,
      modelSize: 'XL',
      maxTokens: 128_000,
      trainingData: 'August 2025',
      modalities: ['text', 'image'],
      toolUse: true,
    },
    link: 'https://platform.openai.com/docs/models/gpt-5',
    legacy: true,
  },
  'gpt-5.1': {
    name: 'OpenAI GPT-5.1',
    description:
      'Flagship model for coding and agentic tasks with configurable reasoning and non-reasoning effort.',
    strengths: [
      'Tune reasoning by saying high, medium, low or no reasoning',
      'Best-in-class tool calling & long-context retrieval',
      'Response controls: reasoning_effort, verbosity',
      'Supports custom tools (plaintext schemas)',
    ],
    limitations: [
      'Higher latency and cost',
      'May be verbose without guidance',
      'Some features roll out incrementally by endpoint',
    ],
    parameters: {
      contextWindow: 400_000,
      modelSize: 'XL',
      maxTokens: 128_000,
      trainingData: 'Sep 30, 2024',
      modalities: ['text', 'images'],
      toolUse: true,
    },
    link: 'https://platform.openai.com/docs/models/gpt-5',
    legacy: true,
  },
  'gpt-5': {
    name: 'OpenAI GPT-5',
    description:
      'Flagship reasoning/coding model with extended deliberation and strong tool use.',
    strengths: [
      'Top-tier coding and multi-step reasoning',
      'Best-in-class tool calling & long-context retrieval',
      'Response controls: reasoning_effort, verbosity',
      'Supports custom tools (plaintext schemas)',
    ],
    limitations: [
      'Higher latency and cost',
      'May be verbose without guidance',
      'Some features roll out incrementally by endpoint',
    ],
    parameters: {
      contextWindow: 400_000,
      modelSize: 'XL',
      maxTokens: 128_000,
      trainingData: 'Sep 30, 2024',
      modalities: ['text', 'images'],
      toolUse: true,
    },
    link: 'https://platform.openai.com/docs/models/gpt-5',
    legacy: true,
  },
  'gpt-5-mini': {
    name: 'OpenAI GPT-5 Mini',
    description:
      'Balanced cost/speed with solid reasoning and coding; ideal default for most agent tasks.',
    strengths: [
      'Fast responses at lower cost',
      'Good coding and function-calling',
      'Reliable tool calling & JSON/structured outputs',
      'Reliable for RAG and tool orchestration',
    ],
    limitations: [
      'Less depth than flagship GPT-5',
      'Shorter context vs. top tier',
      'Slightly higher hallucination risk under heavy abstraction',
    ],
    parameters: {
      contextWindow: 200_000, // pragmatic default
      modelSize: 'M',
      maxTokens: 32_000,
      trainingData: 'Not disclosed',
      modalities: ['text'],
      toolUse: true,
    },
    link: 'https://platform.openai.com/docs/models/gpt-5-mini',
    legacy: true,
  },
  'gpt-5-nano': {
    name: 'OpenAI GPT-5 Nano',
    description:
      'Ultra-fast, low-cost model for lightweight chat, classification, and simple tool flows.',
    strengths: [
      'Very low latency and cost',
      'Great for routing, tagging, short replies',
      'Stable tool/function calling for simple agents',
    ],
    limitations: [
      'Limited reasoning depth',
      'Smaller context window',
      'Not ideal for complex code-gen or multi-hop tasks',
    ],
    parameters: {
      contextWindow: 64_000,
      modelSize: 'S',
      maxTokens: 8_000,
      trainingData: 'Not disclosed',
      modalities: ['text'],
      toolUse: true,
    },
    link: 'https://platform.openai.com/docs/models/gpt-5-nano',
    legacy: true,
  },
  'gpt-o3': {
    name: 'OpenAI o3',
    description: 'Superior reasoning model for complex tasks.',
    strengths: [
      'Leading performance on coding, math, science',
      '1M token context',
      'Structured reasoning outputs',
      'STEM benchmark performance',
      'Extended deliberation capacity',
    ],
    limitations: [
      'Slower because of reasoning',
      'Text-only processing',
      'Verbose intermediate steps',
      'Expensive',
    ],
    parameters: {
      contextWindow: 1000000,
      modelSize: '',
      maxTokens: 100000,
      trainingData: '2025',
      modalities: ['text'],
      toolUse: true,
    },
    link:
      'https://learn.microsoft.com/en-us/azure/ai-services/openai/concepts/models#o-series-models',
    legacy: true,
  },
  'gpt-o3-pro': {
    name: 'OpenAI o3 Pro',
    description:
      'Highest-capability o3 variant with extended compute for the most demanding research and reasoning tasks. Routes through the OpenAI Responses API.',
    strengths: [
      'Maximum reasoning depth with extended compute budget',
      '1M token context',
      'Best for complex STEM, research, and multi-step problems',
      'Structured reasoning outputs',
    ],
    limitations: [
      'Significantly higher cost and latency than o3',
      'Text-only processing',
      'Expensive for simple queries',
    ],
    parameters: {
      contextWindow: 1000000,
      modelSize: '',
      maxTokens: 100000,
      trainingData: '2025',
      modalities: ['text'],
      toolUse: true,
    },
    link: 'https://platform.openai.com/docs/models',
    legacy: true,
  },

  'gpt-4.5-preview': {
    name: 'OpenAI GPT-4.5 (Preview)',
    description:
      "OpenAI's largest expensive preview model (128K context) with multimodal I/O and advanced tool integration.",
    strengths: [
      'Unmatched knowledge and accuracy',
      'Creative writing and conversations',
      'Multimodal input support',
      '128K token context window',
      'Structured outputs and tool use',
    ],
    limitations: [
      'Limited preview access',
      'Extremely expensive',
      'Occasional inaccuracies',
      'Higher cost and latency',
      'Less step-by-step reasoning',
    ],
    parameters: {
      contextWindow: 128000,
      modelSize: '',
      maxTokens: 16384,
      trainingData: 'Up to Oct 2023',
      modalities: ['text', 'image'],
      toolUse: true,
    },
    link: 'https://openai.com/index/introducing-gpt-4-5',
    legacy: true,
  },

  'gpt-4o': {
    name: 'OpenAI GPT-4o (Omni)',
    description:
      'Multilingual AI (128K context) with vision capabilities and parallel function execution used for Azure.',
    strengths: [
      'Simultaneous data type processing',
      'Superior non-English performance',
      'Parity with GPT-4 Turbo',
      'Structured output formatting',
      'Parallel function calling',
    ],
    limitations: [
      'Azure exclusivity',
      'High resource demands',
      '16K output limit',
      'October 2023 knowledge cutoff',
      'Accuracy-focused optimizations',
    ],
    parameters: {
      contextWindow: 128000,
      modelSize: '',
      maxTokens: 16384,
      trainingData: 'Up to Oct 2023',
      modalities: ['text', 'image'],
      toolUse: true,
    },
    link:
      'https://learn.microsoft.com/en-us/azure/ai-services/openai/concepts/models#GPT-4o-and-GPT-4-Turbo',
    legacy: true,
  },

  'gpt-4.1': {
    name: 'OpenAI GPT-41',
    description:
      'Latest OpenAI Model (Context 1M)) with vision capabilities and parallel function execution.',
    strengths: [
      '1 Million token context window',
      'Structured output formatting',
      'Parallel function calling',
    ],
    limitations: [
      'Azure exclusivity',
      'High resource demands',
      'October 2023 knowledge cutoff',
      'Accuracy-focused optimizations',
    ],
    parameters: {
      contextWindow: 1000000,
      modelSize: '',
      maxTokens: 32768,
      trainingData: '5/31/2024',
      modalities: ['text', 'image'],
      toolUse: true,
    },
    link:
      'https://learn.microsoft.com/en-us/azure/ai-services/openai/concepts/models?tabs=global-standard%2Cstandard-chat-completions#gpt-41-series',
    legacy: true,
  },

  'gpt-4.1-mini': {
    name: 'OpenAI GPT-41 mini',
    description: 'Mini 4.1 OpenAI Model (Context 1M)',
    strengths: [
      '1 Million token context window',
      'Fast non-English performance',
      'Structured output formatting',
      'Parallel function calling',
    ],
    limitations: [
      'Azure exclusivity',
      'High resource demands',
      'Accuracy-focused optimizations',
    ],
    parameters: {
      contextWindow: 1000000,
      modelSize: '',
      maxTokens: 32768,
      trainingData: '5/31/2024',
      modalities: ['text', 'image'],
      toolUse: true,
    },
    link:
      'https://learn.microsoft.com/en-us/azure/ai-services/openai/concepts/models?tabs=global-standard%2Cstandard-chat-completions#gpt-41-series',
    legacy: true,
  },

  'gpt-4o-mini': {
    name: 'OpenAI GPT-4o Mini',
    description:
      'Cost-efficient Azure model (128K context) balancing GPT-4o capabilities with lower latency.',
    strengths: [
      'Cost-effective performance',
      'Basic multimodal support',
      'Code optimization',
      'JSON mode compatibility',
      'Strong general knowledge',
    ],
    limitations: [
      'Reduced complex reasoning',
      'Limited vision accuracy',
      'Azure-only availability',
      'October 2023 cutoff',
      'Smaller model size',
    ],
    parameters: {
      contextWindow: 128000,
      modelSize: '',
      maxTokens: 16384,
      trainingData: 'Up to Oct 2023',
      modalities: ['text', 'image'],
      toolUse: true,
    },
    link:
      'https://learn.microsoft.com/en-us/azure/ai-services/openai/concepts/models#GPT-4o-and-GPT-4-Turbo',
    legacy: true,
  },

  /* gpt-4-1106-preview shut down Mar 26, 2026
  'gpt-4-1106-preview': {
    name: 'OpenAI GPT-4 (1106 Preview)',
    description:
      'Beta model (128K context) previewing GPT-4 Turbo features pre-launch.',
    strengths: [
      'Early feature access',
      '128K context preview',
      'Coding improvements',
      'Optimized throughput',
      'Developer feedback loop',
    ],
    limitations: [
      'Temporary availability',
      'Knowledge limitations',
      'Output style inconsistencies',
      'Deprecated features',
      '4K generation limit',
    ],
    parameters: {
      contextWindow: 128000,
      modelSize: '',
      maxTokens: 4096,
      trainingData: 'Up to Apr 2023',
      modalities: ['text', 'image'],
      toolUse: true,
    },
    link:
      'https://techcommunity.microsoft.com/t5/ai-azure-ai-services-blog/azure-openai-service-launches-gpt-4-turbo-and-gpt-3-5-turbo-1106/ba-p/3985962',
    legacy: true,
  }, */
  'gemini-3.7-flash': {
    name: 'Google Gemini 3.7 Flash',
    description:
      "Google's newest Flash model (Aug 2026) — fast agentic workflows, coding, and complex multi-step reasoning with thinking, at introductory pricing.",
    strengths: [
      'Latest-gen Flash with thinking and multi-step reasoning',
      '1M-token context',
      'Intro pricing $0.75/$3.75 per MTok through Dec 31, 2026',
      'Multimodal: text, image, audio, video',
      'Function calling + Google grounding',
    ],
    limitations: [
      'Introductory pricing expires Dec 31, 2026',
      'Lower peak reasoning vs. Pro models',
      'No image generation',
    ],
    parameters: {
      contextWindow: 1_048_576,
      modelSize: '',
      maxTokens: 65_536,
      trainingData: 'Not publicly specified',
      modalities: ['text', 'image', 'audio', 'video'],
      toolUse: true,
    },
    link: 'https://ai.google.dev/gemini-api/docs/models',
    legacy: true,
  },
  'gemini-3.8-flash': {
    name: 'Google Gemini 3.8 Flash',
    description:
      "Google's latest Flash model (GA Sep 2, 2026) — fast agentic workflows, coding, and multi-step reasoning, succeeding 3.7 Flash.",
    strengths: [
      'Latest-gen Flash with thinking and multi-step reasoning',
      '1M-token context',
      '$1.00/$5.00 per MTok',
      'Multimodal: text, image, audio, video',
      'Function calling + Google grounding',
    ],
    limitations: ['Lower peak reasoning vs. Pro models', 'No image generation'],
    parameters: {
      contextWindow: 1_048_576,
      modelSize: '',
      maxTokens: 65_536,
      trainingData: 'Not publicly specified',
      modalities: ['text', 'image', 'audio', 'video'],
      toolUse: true,
    },
    link: 'https://ai.google.dev/gemini-api/docs/models',
  },
  'gemini-3.6-flash': {
    name: 'Google Gemini 3.6 Flash',
    description:
      'Previous Flash model (Jul 2026) — same input price as 3.5 Flash but ~17% cheaper output. Superseded by Gemini 3.7 Flash.',
    strengths: [
      'Improved reasoning over 3.5 Flash',
      '1M-token context',
      '$1.50/$7.50 per MTok — cheaper output than 3.5 Flash',
      'Multimodal: text, image, audio, video',
      'Function calling + Google grounding',
    ],
    limitations: ['No image generation', 'Lower peak reasoning vs. Pro models'],
    parameters: {
      contextWindow: 1_000_000,
      modelSize: 'M',
      maxTokens: 64_000,
      trainingData: 'July 2026',
      modalities: ['text', 'image', 'audio', 'video'],
      toolUse: true,
    },
    link: 'https://ai.google.dev/gemini-api/docs/models',
    legacy: true,
  },
  'gemini-3.1-pro-preview': {
    name: 'Google Gemini 3.1 Pro (Preview)',
    description:
      'Latest Gemini preview — successor to Gemini 3 Pro with enhanced reasoning and multimodal capabilities.',
    strengths: [
      'State-of-the-art reasoning (latest preview)',
      '1M-token context for very long inputs',
      'Multimodal inputs: text, code, images, audio, video',
      'Improved over Gemini 3 Pro',
      'Great with Google ecosystem + grounding',
    ],
    limitations: [
      'Preview status — may have changes or rate limits',
      'Higher latency on complex prompts',
      'No image generation',
    ],
    parameters: {
      contextWindow: 1_000_000,
      modelSize: 'L',
      maxTokens: 65_535,
      trainingData: 'February 2026',
      modalities: ['text', 'image', 'audio', 'video'],
      toolUse: true,
    },
    link: 'https://ai.google.dev/gemini-api/docs/models',
  },
  'gemini-3.1-flash-lite-preview': {
    name: 'Google Gemini 3.1 Flash Lite (Preview)',
    description:
      'Ultra-fast, ultra-cheap Gemini 3.1 preview for high-throughput tasks and routing.',
    strengths: [
      'Lowest latency in Gemini 3.1 family',
      '1M-token context',
      'Cost-efficient for high-volume use',
      'Grounding + function calling',
    ],
    limitations: [
      'Preview status',
      'Reduced reasoning depth',
      'Smaller output limits',
    ],
    parameters: {
      contextWindow: 1_000_000,
      modelSize: 'S',
      maxTokens: 8_000,
      trainingData: 'February 2026',
      modalities: ['text', 'image'],
      toolUse: true,
    },
    link: 'https://ai.google.dev/gemini-api/docs/models',
    legacy: true,
  },
  'gemini-3.1-flash-lite': {
    name: 'Google Gemini 3.1 Flash Lite',
    description:
      'Ultra-fast, ultra-cheap Gemini 3.1 Flash Lite stable GA release (May 2026).',
    strengths: [
      'Lowest latency in Gemini 3.1 family',
      '1M-token context',
      '$0.25/$1.50 per MTok — extremely cost-efficient',
      'Grounding + function calling',
      'Stable GA (supersedes preview)',
    ],
    limitations: ['Reduced reasoning depth vs. Flash/Pro models'],
    parameters: {
      contextWindow: 1_000_000,
      modelSize: 'S',
      maxTokens: 64_000,
      trainingData: 'February 2026',
      modalities: ['text', 'image', 'audio'],
      toolUse: true,
    },
    link: 'https://ai.google.dev/gemini-api/docs/models',
    legacy: true,
  },
  // 'gemini-3.1-flash-live-preview': not available via generateContent API
  'gemini-3.5-flash': {
    name: 'Google Gemini 3.5 Flash',
    description:
      "Google's GA Flash model — frontier intelligence per dollar with 4× faster output than comparable models, optimized for agentic and coding tasks.",
    strengths: [
      '1M-token context for very long inputs',
      '42% better long-range multi-turn performance vs Flash 3',
      '68% token efficiency improvement',
      'Multimodal inputs: text, code, images, audio, video',
      'Great with Google ecosystem + grounding',
    ],
    limitations: ['Lower peak reasoning vs. Pro models', 'No image generation'],
    parameters: {
      contextWindow: 1_000_000,
      modelSize: 'M',
      maxTokens: 64_000,
      trainingData: 'May 2026',
      modalities: ['text', 'image', 'audio', 'video'],
      toolUse: true,
    },
    link: 'https://blog.google/products/gemini/gemini-3-flash/',
  },
  'gemini-3.5-flash-lite': {
    name: 'Google Gemini 3.5 Flash Lite',
    description:
      "Google's budget-tier 3.5 Flash Lite (Jul 2026) — highly cost-efficient for high-volume automated tasks.",
    strengths: [
      'Extremely cheap: $0.30/$2.50 per MTok',
      '1M-token context',
      'Fast inference for high-throughput use cases',
      'Function calling + Google grounding',
    ],
    limitations: ['Reduced reasoning vs. 3.5/3.6 Flash', 'No image generation'],
    parameters: {
      contextWindow: 1_000_000,
      modelSize: 'S',
      maxTokens: 64_000,
      trainingData: 'May 2026',
      modalities: ['text', 'image'],
      toolUse: true,
    },
    link: 'https://ai.google.dev/gemini-api/docs/models',
  },
  'gemini-3-flash-preview': {
    name: 'Google Gemini 3 Flash (Preview)',
    description:
      'Previous high-speed Gemini Flash preview, superseded by Gemini 3.5 Flash GA.',
    strengths: [
      'Ultra-fast inference and low latency',
      '1M-token context for very long inputs',
      'Multimodal inputs: text, code, images, audio, video',
      'Great with Google ecosystem + grounding',
      'Enhanced reasoning at speed',
    ],
    limitations: [
      'Preview status - may have changes',
      'Lower peak reasoning vs. Pro models',
      'No image generation',
    ],
    parameters: {
      contextWindow: 1_000_000,
      modelSize: 'M',
      maxTokens: 64_000,
      trainingData: 'January 2025',
      modalities: ['text', 'image', 'audio', 'video'],
      toolUse: true,
    },
    link: 'https://ai.google.dev/gemini-api/docs/models#gemini-3-flash',
    legacy: true,
  },

  /* gemini-3-pro-preview was shut down March 9, 2026 — use gemini-3.1-pro-preview instead
  'gemini-3-pro-preview': { ... } */
  'gemini-2.5-pro': {
    name: 'Google Gemini 2.5 Pro',
    description:
      'Google’s highest-quality Gemini for advanced reasoning, code, and multimodal understanding.',
    strengths: [
      '1M-token context for very long inputs',
      'Multimodal inputs: text, code, images, audio, video',
      '“Thinking” mode and function calling',
      'Great with Google ecosystem + grounding',
    ],
    limitations: [
      'Latency can be higher on complex prompts',
      'Some features vary by Google AI Studio vs. Vertex AI',
      'Function-calling semantics differ from OpenAI',
    ],
    parameters: {
      contextWindow: 1_000_000,
      modelSize: 'L',
      maxTokens: 65_535,
      trainingData: 'Not disclosed',
      modalities: ['text', 'image', 'audio'],
      toolUse: true,
    },
    link: 'https://ai.google.dev/gemini-api/docs/models#gemini-2.5-pro',
    legacy: true,
  },
  'gemini-2.5-flash': {
    name: 'Google Gemini 2.5 Flash',
    description:
      'Speed-optimized Gemini for interactive UX, summaries, and high-throughput tool use.',
    strengths: [
      'Low latency and cost',
      '1M-token context, multimodal inputs',
      '"Thinking" toggle for extra deliberation',
      'Grounding + function calling',
    ],
    limitations: [
      'Lower peak reasoning vs. Pro',
      'Occasional quality drop on complex multi-hop tasks',
    ],
    parameters: {
      contextWindow: 1_000_000, // many deployments allow very large; adjust if needed
      modelSize: 'M',
      maxTokens: 32_000,
      trainingData: 'Not disclosed',
      modalities: ['text', 'image', 'audio'],
      toolUse: true,
    },
    link: 'https://ai.google.dev/gemini-api/docs/models#gemini-2.5-flash',
    legacy: true,
  },
  'gemini-2.5-flash-lite': {
    name: 'Google Gemini 2.5 Flash Lite',
    description:
      'Lowest-latency, lowest-cost Gemini tier for microtasks, routing, and UI hints.',
    strengths: [
      'Fastest, most cost-efficient 2.5 tier',
      '1M-token context',
      '“Thinking” at adjustable budgets',
      'Grounding + function calling',
    ],
    limitations: [
      'Reduced reasoning depth and creativity',
      'Smaller effective context and output lengths',
    ],
    parameters: {
      contextWindow: 256_000, // conservative default for the lite tier
      modelSize: 'S',
      maxTokens: 8_000,
      trainingData: 'Not disclosed',
      modalities: ['text', 'image'], // add 'audio' if enabled
      toolUse: true,
    },
    link: 'https://ai.google.dev/gemini-api/docs/models#gemini-2.0-flash-lite',
    legacy: true,
  },
  'gemini-1.5-pro-latest': {
    name: 'Google Gemini 1.5 Pro',
    description:
      "Google's million-token context multimodal model (text/image/audio/video)",
    strengths: [
      'Native multimodality',
      'Long document analysis',
      'Enterprise-ready outputs',
      'High factual reliability',
      'Multi-instruction handling',
    ],
    limitations: [
      'Closed architecture',
      'Text-only outputs',
      'Processing delays',
      '2024 knowledge cutoff',
      'No tool integration',
    ],
    parameters: {
      contextWindow: null,
      modelSize: '',
      maxTokens: 8192,
      trainingData: 'Up to 2024',
      modalities: ['text', 'image', 'audio', 'video'],
      toolUse: false,
    },
    link:
      'https://blog.google/technology/google-deepmind/google-gemini-ai-update-december-2024/',
    legacy: true,
  },

  'gemini-1.5-flash-latest': {
    name: 'Google Gemini 1.5 Flash',
    description:
      "Google's lightning-fast variant optimized for high-throughput tasks.",
    strengths: [
      'Low-latency responses',
      'Versatile task handling',
      'Multimodal processing',
      'Resource efficiency',
      'Instruction adherence',
    ],
    limitations: [
      'Simpler task focus',
      'Basic vision analysis',
      'Context limitations',
      'Standard knowledge cutoff',
      'No autonomous actions',
    ],
    parameters: {
      contextWindow: null,
      modelSize: '',
      maxTokens: 8192,
      trainingData: 'Up to 2024',
      modalities: ['text', 'image', 'audio', 'video'],
      toolUse: false,
    },
    link:
      'https://blog.google/technology/google-deepmind/google-gemini-ai-update-december-2024/',
    legacy: true,
  },

  'gemini-2.0-flash': {
    name: 'Google Gemini 2.0 Flash',
    description:
      'Faster million-token model (1M context) with native tool integration.',
    strengths: [
      '1M token context',
      'Lower latency',
      'Native tool use',
      'Benchmark performance',
      'Cloud accessibility',
    ],
    limitations: [
      'Text-focused outputs',
      'Full context delays',
      'Smaller output limit',
      'Simpler task focus',
      'Integration complexity',
    ],
    parameters: {
      contextWindow: 1000000,
      modelSize: '',
      maxTokens: 8192,
      trainingData: 'Up to 2024',
      modalities: ['text', 'image', 'audio', 'video'],
      toolUse: true,
    },
    link: 'https://developers.googleblog.com/en/gemini-2-family-expands/',
    legacy: true,
  },
  'gemini-2.0-flash-lite': {
    name: 'Google Gemini 2.0 Flash Lite',
    description:
      'Optimized for fastest response (1M context) and cost efficiency',
    strengths: [
      'Super Low Latency',
      '1M token context',
      'Native tool use',
      'Fast',
      'Part of Google Gemini',
    ],
    limitations: [
      'Text-focused outputs',
      'Optimized for speed not reasoning',
      'Smaller output limit',
      'Cheapest Gemini model',
      'Integration complexity',
    ],
    parameters: {
      contextWindow: 1048576,
      modelSize: '',
      maxTokens: 8192,
      trainingData: 'Up to August 2024',
      modalities: ['text'],
      toolUse: true,
    },
    link: 'https://ai.google.dev/gemini-api/docs/models#gemini-2.0-flash-lite',
    legacy: true,
  } /* This Model has a montly limit that is used up quickly
  'gemini-2.5-pro-exp-03-25': {
      name: 'Google Gemini 2.5 Pro Experimental Preview',
      description: 'Enhanced thinking and reasoning (1M context), multimodal understanding, advanced coding',
      strengths: [
        'Enhanced thinking',
        '1M token context',
        'Enterprise-grade reliability',
        'Multimodal integration',
        'Advanced planning capabilities'
      ],
      limitations: [
        'Limited availability',
        'High resource demands',
        'Experimental preview status',
        'Niche use benefits',
        'Unstable APIs'
      ],
      parameters: {
        contextWindow: 1048576,
        modelSize: '',
        maxTokens: 65536,
        trainingData: 'Up to 2024',
        modalities: ['text', 'image', 'video'],
        toolUse: true
      },
      link: 'https://ai.google.dev/gemini-api/docs/models#gemini-2.5-pro-preview-03-25'
    },*/,
  /* This model is gone now
  'learnlm-1.5-pro-experimental': {
    name: 'Google LearnLM 1.5 Pro (Experimental)',
    description: 'Google\'s education-focused model with massive 2 million context for curriculum analysis.',
    strengths: [
      '2M token context',
      'Pedagogical alignment',
      'Multimodal tutoring',
      'Precise document recall',
      'Real-time citations'
    ],
    limitations: [
      'Education-specific focus',
      'Hardware requirements',
      'Limited availability',
      'Internet dependency',
      'Verbose explanations'
    ],
    parameters: {
      contextWindow: 2000000,
      modelSize: '',
      maxTokens: 8192,
      trainingData: 'Up to 2024',
      modalities: ['text', 'image', 'audio', 'video'],
      toolUse: true
    },
    link: 'https://thinglabs.io/learnlm-1-5-pro-experimental'
  }, */

  'claude-fable-5': {
    name: 'Anthropic Claude Fable 5',
    description:
      "Anthropic's highest-capability generally available model, above Opus 5. Excels at the hardest reasoning, agentic coding, and research tasks. Adaptive thinking is always on and cannot be disabled. Very expensive and slower than Opus/Sonnet — use only when maximum capability is required.",
    strengths: [
      'Highest capability of any Anthropic model',
      '1M token context window',
      '128K max output tokens',
      'Adaptive thinking always on for deeper reasoning',
      'Strong tool use verified in LangGraph',
      'Text and image input',
    ],
    limitations: [
      'Premium pricing ($10/$50 per MTok) — most expensive Claude model',
      'Slower than Opus 5 and Sonnet due to adaptive thinking overhead',
      'Adaptive thinking cannot be disabled',
      'Overkill for simple or routine tasks',
    ],
    parameters: {
      contextWindow: 1_000_000,
      modelSize: '',
      maxTokens: 128_000,
      trainingData: 'Unknown',
      modalities: ['text', 'image'],
      toolUse: true,
    },
    link: 'https://docs.claude.com/en/docs/about-claude/models/overview',
  },
  'claude-opus-5': {
    name: 'Anthropic Claude Opus 5',
    description:
      "Anthropic's flagship model for complex agentic coding and enterprise work — Anthropic's recommended default choice as of July 2026. Supersedes Opus 4.8.",
    strengths: [
      'Anthropic-recommended model for complex agentic coding and enterprise work',
      '1M token context window (default)',
      'Best for complex reasoning, coding, and agent tasks',
      '128K max output tokens',
    ],
    limitations: [
      'Higher latency than Sonnet and Haiku',
      'Premium tier pricing ($5/$25 per MTok)',
    ],
    parameters: {
      contextWindow: 1000000,
      modelSize: '',
      maxTokens: 128000,
      trainingData: 'Unknown',
      modalities: ['text', 'image'],
      toolUse: true,
    },
    link: 'https://docs.claude.com/en/docs/about-claude/models/overview',
    legacy: true,
  },
  'claude-opus-5-5': {
    name: 'Anthropic Claude Opus 5.5',
    description:
      "Anthropic's latest Opus (Sep 22, 2026) — upgraded flagship for the hardest reasoning, agentic coding, and enterprise work. Uses adaptive thinking.",
    strengths: [
      'Latest Opus-tier flagship',
      '1M token context window',
      'Best for complex reasoning, coding, and agent tasks',
      'Adaptive thinking for deeper reasoning',
      '128K max output tokens',
    ],
    limitations: [
      'Higher latency than Sonnet and Haiku',
      'Premium tier pricing',
    ],
    parameters: {
      contextWindow: 1_000_000,
      modelSize: '',
      maxTokens: 128_000,
      trainingData: 'Unknown',
      modalities: ['text', 'image'],
      toolUse: true,
    },
    link: 'https://platform.claude.com/docs/en/models/opus-5-5/overview',
  },
  'claude-opus-4-8': {
    name: 'Anthropic Claude Opus 4.8',
    description:
      "Anthropic's previous flagship model for complex reasoning, long-horizon agentic coding, and high-autonomy work — with Fast Mode and dynamic workflows. Superseded by Opus 5.",
    strengths: [
      'Highest intelligence in the Claude 4.x family',
      '1M token context window (default)',
      'Best for complex reasoning, coding, and agent tasks',
      'Fast Mode for low-latency responses',
      'Effort control and dynamic workflows',
      'Improved honesty and reduced hallucinations',
      '128K max output tokens',
    ],
    limitations: [
      'Higher latency than Sonnet and Haiku',
      'Premium tier pricing ($5/$25 per MTok)',
      'Fast Mode costs more ($10/$50 per MTok)',
    ],
    parameters: {
      contextWindow: 1000000,
      modelSize: '',
      maxTokens: 128000,
      trainingData: 'March 2026',
      modalities: ['text', 'image'],
      toolUse: true,
    },
    link: 'https://www.anthropic.com/news/claude-opus-4-8',
    legacy: true,
  },
  'claude-opus-4-7': {
    name: 'Anthropic Claude Opus 4.7',
    description:
      'Previous most capable Claude model — top-tier reasoning, coding, and agentic performance. Superseded by Opus 4.8.',
    strengths: [
      'Highest intelligence in the Claude 4 family',
      '200K context (1M with beta header)',
      'Best for complex reasoning, coding, and agent tasks',
      'Extended thinking support',
      '128K max output tokens',
    ],
    limitations: [
      'Higher latency than Sonnet and Haiku',
      'Requires context-1m-2025-08-07 beta header for 1M context',
      'Premium tier pricing',
    ],
    parameters: {
      contextWindow: 200000,
      modelSize: '',
      maxTokens: 128000,
      trainingData: 'August 2025',
      modalities: ['text', 'image'],
      toolUse: true,
    },
    link: 'https://docs.anthropic.com/en/docs/about-claude/models',
    legacy: true,
  },
  'claude-sonnet-5': {
    name: 'Anthropic Claude Sonnet 5',
    description:
      "Anthropic's most agentic Sonnet yet (released June 30, 2026) — plans, uses tools like browsers and terminals, and runs autonomously at a level that recently required larger, more expensive models. Default Claude model on Free and Pro plans.",
    strengths: [
      'Best-in-class agentic coding and tool use',
      '1M-token context window (default)',
      '128K max output tokens',
      'Substantial gains over Sonnet 4.6 on reasoning + knowledge work',
      'Lower cost than Opus tier',
    ],
    limitations: [
      'Slightly less reasoning depth than Opus 4.8',
      'Intro pricing ($2/$10 per MTok) ends Aug 31, 2026 — then $3/$15',
    ],
    parameters: {
      contextWindow: 1_000_000,
      modelSize: '',
      maxTokens: 128000,
      trainingData: 'April 2026',
      modalities: ['text', 'image'],
      toolUse: true,
    },
    link: 'https://www.anthropic.com/news/claude-sonnet-5',
    legacy: true,
  },
  'claude-sonnet-5-5': {
    name: 'Anthropic Claude Sonnet 5.5',
    description:
      "Anthropic's latest Sonnet (Sep 28, 2026) — 30%+ faster output and up to 30% lower cost per task than Sonnet 5. Strong agentic coding and tool use.",
    strengths: [
      '30%+ faster output than Sonnet 5',
      'Up to 30% lower cost per task',
      '1M-token context window',
      'Best-in-class agentic coding and tool use',
    ],
    limitations: ['Slightly less reasoning depth than Opus tier'],
    parameters: {
      contextWindow: 1_000_000,
      modelSize: '',
      maxTokens: 128000,
      trainingData: 'Not disclosed',
      modalities: ['text', 'image'],
      toolUse: true,
    },
    link: 'https://www.anthropic.com/claude-sonnet-5-5',
  },
  'claude-sonnet-4-6': {
    name: 'Anthropic Claude Sonnet 4.6',
    description:
      'Previous Sonnet — good balance of speed and intelligence with 200K context. Superseded by Sonnet 5.',
    strengths: [
      'Superior balance of speed and intelligence',
      '200K context (1M with beta header)',
      'Excellent coding, analysis, and writing',
      'Extended thinking support',
      'Lower cost than Opus 4.6',
    ],
    limitations: [
      'Slightly less reasoning depth than Opus 4.6',
      'Requires context-1m-2025-08-07 beta header for 1M context',
      'Premium tier pricing ($3/$15 per MTok)',
    ],
    parameters: {
      contextWindow: 200000,
      modelSize: '',
      maxTokens: 64000,
      trainingData: 'August 2025',
      modalities: ['text', 'image'],
      toolUse: true,
    },
    link: 'https://docs.anthropic.com/en/docs/about-claude/models',
    legacy: true,
  },
  'claude-opus-4-6': {
    name: 'Anthropic Claude 4.6 Opus',
    description:
      'Most intelligent model for building agents and coding with 1M token context support.',
    strengths: [
      'Top-tier reasoning, coding, and multilingual performance',
      '200K context (1M with beta header)',
      'Best model for coding and enterprise agents',
      'Extended and adaptive thinking support',
      '128K max output tokens',
    ],
    limitations: [
      'Moderate latency compared to Sonnet/Haiku',
      'Requires context-1m-2025-08-07 beta header for 1M context',
      'Long contexts incur additional pricing',
      'Premium tier pricing ($5/$25 per MTok)',
    ],
    parameters: {
      contextWindow: 200000,
      modelSize: '',
      maxTokens: 128000,
      trainingData: 'August 2025',
      modalities: ['text', 'image'],
      toolUse: true,
    },
    link: 'https://docs.anthropic.com/en/docs/about-claude/models',
    legacy: true,
  },
  'claude-opus-4-5-20251101': {
    name: 'Anthropic Claude 4.5 Opus',
    description:
      'Frontier Opus‑tier model with state-of-the-art reasoning, coding, and safety',
    legacy: true,
    strengths: [
      'State-of-the-art reasoning and problem solving across domains',
      'Opus-level capability at significantly lower cost ($5/$25 per million tokens)',
      '200K context with strong performance on long, multi-step conversations',
      'Frontier-level software engineering performance (SWE-bench Multilingual leader on 7/8 languages)',
      'Improved vision, mathematics, and multilingual capabilities',
      'High robustness to prompt injection and other adversarial attacks',
      'Adaptive effort controls for balancing speed, cost, and capability',
    ],
    limitations: [
      'Higher latency and cost than lighter models for simple queries',
      'May pursue creative but unanticipated solutions that diverge from benchmark expectations',
      'Some tasks still require human judgment, domain review, and code/security audits',
      'Very long contexts can still incur noticeable latency and higher total spend',
      'Dependent on safe prompt design and system configuration for high-stakes deployments',
    ],
    parameters: {
      contextWindow: 200000,
      modelSize: '',
      maxTokens: 32000,
      trainingData: 'Up to March 2025',
      modalities: ['text', 'image'],
      toolUse: true,
    },
    link: 'https://www.anthropic.com/news/claude-opus-4-5',
  },
  'claude-opus-4-1': {
    name: 'Anthropic Claude 4.1 Opus',
    description: 'Most capable model',
    strengths: [
      'Highest level of intelligence',
      'Recent March 2025 training',
      '200K context',
      'Vision analysis',
      'Adaptive thinking modes',
    ],
    limitations: [
      'Long context latency',
      'Premium pricing',
      'Safety filters',
      'Access restrictions',
    ],
    parameters: {
      contextWindow: 200000,
      modelSize: '',
      maxTokens: 32000,
      trainingData: 'March 2025',
      modalities: ['text', 'image'],
      toolUse: true,
    },
    link: 'https://www.anthropic.com/claude',
    legacy: true,
  },

  'claude-opus-4-0': {
    name: 'Anthropic Claude 4.0 Opus',
    description: 'Most capable model',
    strengths: [
      'Very high intelligence',
      'Recent March 2025 training',
      '200K context',
      'Vision analysis',
      'Adaptive thinking modes',
    ],
    limitations: [
      'Long context latency',
      'Premium pricing',
      'Safety filters',
      'Access restrictions',
    ],
    parameters: {
      contextWindow: 200000,
      modelSize: '',
      maxTokens: 32000,
      trainingData: 'March 2025',
      modalities: ['text', 'image'],
      toolUse: true,
    },
    link: 'https://www.anthropic.com/claude',
    legacy: true,
  },

  'claude-sonnet-4-5-20250929': {
    name: 'Anthropic Claude 4.5 Sonnet',
    legacy: true,
    description:
      'Smart model for complex agents and coding with improved performance.',
    strengths: [
      'Best model for agents, coding, computer use',
      'Long Running Tasks',
      '200K context (1M beta)',
      'Enhanced reasoning capabilities',
      'Extended thinking support',
    ],
    limitations: [
      'Long context latency',
      'Premium pricing',
      'Safety filters',
      'Access restrictions',
    ],
    parameters: {
      contextWindow: 200000,
      modelSize: '',
      maxTokens: 64000,
      trainingData: 'July 2025',
      modalities: ['text', 'image'],
      toolUse: true,
    },
    link: 'https://www.anthropic.com/claude/sonnet',
  },

  'claude-haiku-4-5-20251001': {
    name: 'Anthropic Claude 4.5 Haiku',
    description:
      'Fastest model with near-frontier intelligence, great on coding, computer use, and agent tasks.',
    strengths: [
      'Fastest response times',
      'Coding & Computer use',
      'Agent Tasks',
      '200K context',
      'Extended thinking support',
    ],
    limitations: [
      'Lower reasoning depth than Sonnet',
      'Premium pricing for speed',
      '2025 cutoff',
      'Safety restrictions',
    ],
    parameters: {
      contextWindow: 200000,
      modelSize: '',
      maxTokens: 64000,
      trainingData: 'July 2025',
      modalities: ['text', 'image'],
      toolUse: true,
    },
    link: 'https://www.anthropic.com/claude/haiku',
  },

  'claude-sonnet-4-0': {
    name: 'Anthropic Claude 4.0 Sonnet',
    description: 'High-performance model',
    strengths: [
      'Excellent search and evaluation',
      'Recent March 2025 training',
      '200K context',
      'Vision analysis',
      'Adaptive thinking modes',
    ],
    limitations: [
      'Long context latency',
      'Premium pricing',
      'Safety filters',
      'Access restrictions',
    ],
    parameters: {
      contextWindow: 200000,
      modelSize: '',
      maxTokens: 64000,
      trainingData: 'March 2025',
      modalities: ['text', 'image'],
      toolUse: true,
    },
    link: 'https://www.anthropic.com/claude/sonnet',
    legacy: true,
  },
  'claude-3-7-sonnet-latest': {
    name: 'Anthropic Claude 3.7 Sonnet',
    description:
      'Hybrid reasoning model with code execution and vision capabilities.',
    strengths: [
      'Excellent search and evaluation',
      'Code debugging',
      '200K context',
      'Vision analysis',
      'Adaptive thinking modes',
    ],
    limitations: [
      'Long context latency',
      'Premium pricing',
      'Mid-2024 cutoff',
      'Safety filters',
      'Access restrictions',
    ],
    parameters: {
      contextWindow: 200000,
      modelSize: '',
      maxTokens: null,
      trainingData: 'Up to 2024',
      modalities: ['text', 'image'],
      toolUse: true,
    },
    link: 'https://www.anthropic.com/claude/sonnet',
    legacy: true,
  },

  'claude-3-5-haiku-latest': {
    name: 'Anthropic Claude 3.5 Haiku',
    description:
      'Speed-optimized model (100K context) balancing performance and cost.',
    strengths: [
      'Rapid responses',
      'Cost efficiency',
      'Code assistance',
      '100K context',
      'Tool integration',
    ],
    limitations: [
      'Reduced context',
      'Text-only focus',
      '2024 cutoff',
      'Reasoning limits',
      'Safety restrictions',
    ],
    parameters: {
      contextWindow: 100000,
      modelSize: '',
      maxTokens: null,
      trainingData: 'Up to 2024',
      modalities: ['text', 'image'],
      toolUse: true,
    },
    link: 'https://www.anthropic.com/claude/haiku',
    legacy: true,
  },

  'claude-3-5-sonnet-latest': {
    name: 'Anthropic Claude 3.5 Sonnet',
    description:
      'High-performance (200K context) model with academic benchmarks and writing quality.',
    strengths: [
      'Academic benchmarking',
      '200K context',
      'Visual interpretation',
      'Natural language generation',
      'Speed optimizations',
    ],
    limitations: [
      'Superseded model',
      'High costs',
      'Limited availability',
      'Vision access',
      '2023 cutoff',
    ],
    parameters: {
      contextWindow: 200000,
      modelSize: '',
      maxTokens: null,
      trainingData: 'Up to 2023',
      modalities: ['text', 'image'],
      toolUse: true,
    },
    link: 'https://www.anthropic.com/news/claude-3-5-sonnet',
    legacy: true,
  },

  'claude-3-opus-latest': {
    name: 'Anthropic Claude 3 Opus',
    description:
      'Original flagship model (100K context) with constitutional AI principles.',
    strengths: [
      'Legal analysis',
      '100K context',
      'Early vision',
      'Detailed explanations',
      'Safety focus',
    ],
    limitations: [
      'Performance lag',
      'Vision limitations',
      'Deprecated status',
      'Context constraints',
      'Early knowledge',
    ],
    parameters: {
      contextWindow: 100000,
      modelSize: '',
      maxTokens: null,
      trainingData: 'Up to 2023',
      modalities: ['text', 'image'],
      toolUse: true,
    },
    link: 'https://www.anthropic.com/news/claude-3-5-sonnet',
    legacy: true,
  },

  'claude-3-sonnet-20240229': {
    name: 'Anthropic Claude 3 Sonnet (2024-02-29)',
    description: 'Mid-tier beta model (100K context) with early tool testing.',
    strengths: [
      'Conversation handling',
      '100K context',
      'Early tool testing',
      'Developer feedback',
      'Transitional features',
    ],
    limitations: [
      'Historical version',
      'Beta quirks',
      'Limited vision',
      'Output constraints',
      'Access restrictions',
    ],
    parameters: {
      contextWindow: 100000,
      modelSize: '',
      maxTokens: null,
      trainingData: 'Up to 2023',
      modalities: ['text'],
      toolUse: true,
    },
    link: 'https://docs.anthropic.com',
    legacy: true,
  },

  /* claude-3-haiku-20240307 retired April 19, 2026 — use claude-haiku-4-5-20251001 instead
  'claude-3-haiku-20240307': {
    name: 'Anthropic Claude 3 Haiku (2024-03-07)',
    description: 'Lightweight chat model (100K context) pre-3.5 improvements.',
    strengths: [
      'Live chat',
      'Cost-effective',
      'Basic coding',
      'Safety testing',
      'API integration',
    ],
    limitations: [
      'Capability gaps',
      'Context limits',
      'Text-only',
      'Outdated version',
      'Brevity focus',
    ],
    parameters: {
      contextWindow: 100000,
      modelSize: '',
      maxTokens: null,
      trainingData: 'Up to 2023',
      modalities: ['text'],
      toolUse: true,
    },
    link: 'https://docs.anthropic.com',
    legacy: true,
  }, */

  'claude-2.1': {
    name: 'Anthropic Claude 2.1',
    description:
      'Enterprise-focused update (200K context) with reduced hallucinations.',
    strengths: [
      'Document analysis',
      'Reduced hallucinations',
      'System prompts',
      'Legal compliance',
      'Trust improvements',
    ],
    limitations: [
      'Processing delays',
      'Residual errors',
      'Beta tooling',
      'Knowledge cutoff',
      'Business focus',
    ],
    parameters: {
      contextWindow: 200000,
      modelSize: '',
      maxTokens: 200000,
      trainingData: 'Up to 2023',
      modalities: ['text'],
      toolUse: true,
    },
    link: 'https://www.anthropic.com/news/claude-2-1',
    legacy: true,
  },
  /* meta-llama/llama-4-scout-17b-16e-instruct deprecated on Groq April 15, 2026 — use openai/gpt-oss-120b */
  'groq-llama-3.3-70b-versatile': {
    name: 'Meta LLaMA 3.3 70B (groq)',
    description:
      'Open-source model family (128K context) with multilingual enhancements. Being deprecated by Groq on August 16, 2026 — migrate to GPT-OSS 120B or Qwen 3.6 27B.',
    strengths: [
      'Fast, open source model',
      'exceptional performance across multiple benchmarks',
      'Excellent Math',
      'Multilingual',
      'Meta integration',
    ],
    limitations: [
      'Scheduled for Groq deprecation on Aug 16, 2026',
      'Context constraints',
      'Performance gap',
      'Prompt sensitivity',
    ],
    parameters: {
      contextWindow: 131072,
      modelSize: '70B',
      maxTokens: 32768,
      trainingData: 'December 2023',
      modalities: ['text'],
      toolUse: true,
    },
    link: 'https://console.groq.com/docs/model/llama-3.3-70b-versatile',
    legacy: true,
  },
  'groq-llama-3.1-8b-instant': {
    name: 'Meta LLaMA 3.1 8B Instant (Groq)',
    description:
      'Ultra-fast, ultra-cheap open-source model for routing, classification, and simple tasks via Groq.',
    strengths: [
      'Very low latency and cost',
      '128K context window',
      'Fast inference via Groq LPU',
      'Good for simple tasks and routing',
    ],
    limitations: [
      'Limited reasoning depth',
      'Smaller model size',
      'Not ideal for complex multi-hop tasks',
    ],
    parameters: {
      contextWindow: 131072,
      modelSize: '8B',
      maxTokens: 8192,
      trainingData: 'Up to 2023',
      modalities: ['text'],
      toolUse: true,
    },
    link: 'https://console.groq.com/docs/models',
    legacy: true,
  },
  /* meta-llama/llama-4-scout-17b-16e-instruct not available via Groq API */
  /* meta-llama/llama-4-maverick-17b-128e-instruct deprecated on Groq March 9, 2026 */
  'groq-openai/gpt-oss-120b': {
    name: 'OpenAI GPT-OSS 120B (groq)',
    description:
      'Open-source flagship model (128K context) from OpenAI with reasoning capabilities.',
    strengths: [
      'Fast inference (~500 t/s)',
      'Exceptional performance across benchmarks',
      'Excellent agentic performance',
      'Multilingual support',
      'Good structured output support',
    ],
    limitations: [
      'Higher cost than lighter models',
      'Context constraints',
      'Prompt sensitivity',
    ],
    parameters: {
      contextWindow: 131072,
      modelSize: '120B',
      maxTokens: 65536,
      trainingData: 'September 2024',
      modalities: ['text'],
      toolUse: true,
    },
    link: 'https://console.groq.com/docs/model/openai/gpt-oss-120b',
  },
  'groq-openai/gpt-oss-20b': {
    name: 'OpenAI GPT-OSS 20B (groq)',
    description:
      'Compact open-source model (128K context) from OpenAI — faster and cheaper than 120B.',
    strengths: [
      'Very fast inference',
      'Cost-effective for high-volume use',
      'Good general performance',
      'Multilingual support',
      'Structured output support',
    ],
    limitations: [
      'Less capable than 120B variant',
      'Context constraints',
      'Not ideal for complex reasoning',
    ],
    parameters: {
      contextWindow: 131072,
      modelSize: '20B',
      maxTokens: 32768,
      trainingData: 'September 2024',
      modalities: ['text'],
      toolUse: true,
    },
    link: 'https://console.groq.com/docs/models',
  },
  'command-a-03-2025': {
    name: 'Cohere Command A (Mar 2025)',
    description:
      'Previous Cohere flagship (256K context) for advanced reasoning, RAG, and agentic workflows. Superseded by newer Cohere releases.',
    strengths: [
      '256K context window',
      'High reasoning depth',
      'Tool & agent compatibility',
      'Structured response control',
      'Strong general performance',
    ],
    limitations: [
      'Higher latency under load',
      'Premium pricing tier',
      'Occasional verbosity',
      'Limited multimodality',
      'Requires fine prompt control',
    ],
    parameters: {
      contextWindow: 256000,
      modelSize: '~111B parameters',
      maxTokens: 4096,
      trainingData: 'Up to early 2025',
      modalities: ['text'],
      toolUse: true,
    },
    link: 'https://docs.cohere.com/v2/docs/models#command-a-03-2025',
    legacy: true,
  },
  /*
    'command-a-reasoning-08-2025': {
      name: 'Cohere Command A Reasoning (Aug 2025)',
      description: 'Reasoning-specialized variant of Command A, tuned for logic-heavy and multi-step reasoning tasks.',
      strengths: [
        'Advanced reasoning chain',
        'Improved mathematical accuracy',
        'Long-context planning',
        'Agent orchestration',
        'Reliable structured output'
      ],
      limitations: [
        'Slightly slower responses',
        'Higher compute cost',
        'Occasional overthinking',
        'Text-only',
        'Experimental fine control'
      ],
      parameters: {
        contextWindow: 256000,
        modelSize: '~111B parameters (tuned)',
        maxTokens: 4096,
        trainingData: 'Up to mid 2025',
        modalities: ['text'],
        toolUse: true
      },
      link: 'https://docs.cohere.com/v2/docs/models#command-a-reasoning-08-2025'
    }, */

  'command-r7b-12-2024': {
    name: 'Cohere Command R7B (Dec 2024)',
    description:
      'Compact and efficient model (128K context) optimized for retrieval, summaries, and cost efficiency.',
    strengths: [
      '128K context',
      'Low latency',
      'Lightweight deployment',
      'Strong summarization',
      'Lower operational cost',
    ],
    limitations: [
      'Reduced reasoning capacity',
      'Occasional factual drift',
      'Limited multi-turn depth',
      'Text-only',
      'Older architecture',
    ],
    parameters: {
      contextWindow: 128000,
      modelSize: '~7B parameters',
      maxTokens: 4096,
      trainingData: 'Up to late 2024',
      modalities: ['text'],
      toolUse: false,
    },
    link: 'https://docs.cohere.com/v2/docs/models#command-r7b-12-2024',
  },
  /*
    'command-a-vision-07-2025': {
      name: 'Cohere Command A Vision (Jul 2025)',
      description: 'Multimodal variant of Command A capable of understanding and generating from image + text inputs.',
      strengths: [
        'Image + text input',
        'Document OCR + Q&A',
        'Visual reasoning',
        'Multimodal embeddings',
        'Agent + tool ready'
      ],
      limitations: [
        'Limited image generation',
        'Higher memory usage',
        'Experimental visual reasoning',
        'Longer load times',
        'Premium tier'
      ],
      parameters: {
        contextWindow: 256000,
        modelSize: '~111B parameters (multimodal)',
        maxTokens: 4096,
        trainingData: 'Up to mid 2025',
        modalities: ['text', 'image'],
        toolUse: true
      },
      link: 'https://docs.cohere.com/v2/docs/models#command-a-vision-07-2025'
    },
    */
  'deepseek-v4-flash': {
    name: 'DeepSeek V4 Flash',
    description:
      'Next-generation MoE chat model (1M context). Now routes to DeepSeek-V4-Flash-0731 weights. Function calling, JSON mode, Responses API, and Anthropic API supported. Pricing shifts to peak/offpeak schedule on Aug 16 2026.',
    strengths: [
      '1M token context window',
      '~384K max output tokens',
      'Supports thinking and non-thinking modes',
      'Function calling + JSON output',
      'Dramatically better reasoning than V3.1',
      'Lowest cost in DeepSeek V4 family',
    ],
    limitations: [
      'Output tokens include thinking tokens in reasoning mode',
      'Pricing becomes time-of-day dependent after Aug 16 2026 (UTC peak/offpeak)',
    ],
    parameters: {
      contextWindow: 1048576,
      modelSize: 'MoE',
      maxTokens: 384000,
      trainingData: 'Up to 2026',
      modalities: ['text'],
      toolUse: true,
    },
    link: 'https://api-docs.deepseek.com/quick_start/pricing',
    legacy: true,
  },

  'deepseek-v4-flash-thinking': {
    name: 'DeepSeek V4 Flash (Thinking)',
    description:
      'DeepSeek V4 Flash (now V4-Flash-0731 weights) with extended chain-of-thought reasoning enabled. Provider supports tool calling in thinking mode, but FFAI treats thinking variants as reasoning-only (no tools) to avoid mixed output.',
    strengths: [
      '1M token context window',
      'Extended chain-of-thought reasoning',
      'More accurate on complex analytical tasks',
      'Same fast inference as V4 Flash',
    ],
    limitations: [
      'No tool use in FFAI (provider supports it, but FFAI disables tools for thinking variants)',
      'Output tokens include reasoning tokens',
      'Not suitable for agent/tool workflows in FFAI',
    ],
    parameters: {
      contextWindow: 1048576,
      modelSize: 'MoE',
      maxTokens: 384000,
      trainingData: 'Up to 2026',
      modalities: ['text'],
      toolUse: false,
    },
    link: 'https://api-docs.deepseek.com/quick_start/pricing',
    legacy: true,
  },

  'deepseek-v4-pro': {
    name: 'DeepSeek V4 Pro',
    description:
      'Premium DeepSeek V4 model. Now routes to DeepSeek-V4-Pro-0813 weights with enhanced reasoning, 1M context, function calling, and JSON/Responses API support. Pricing shifts to peak/offpeak schedule on Aug 16 2026.',
    strengths: [
      '1M token context window',
      '~384K max output tokens',
      'Superior reasoning and analytical performance',
      'Function calling + JSON output',
      'Best for complex multi-step tasks',
      'Highest accuracy in DeepSeek V4 family',
    ],
    limitations: [
      'Higher cost than V4 Flash',
      'Output tokens include thinking tokens in reasoning mode',
      'Pricing becomes time-of-day dependent after Aug 16 2026 (UTC peak/offpeak)',
    ],
    parameters: {
      contextWindow: 1048576,
      modelSize: 'MoE',
      maxTokens: 384000,
      trainingData: 'Up to 2026',
      modalities: ['text'],
      toolUse: true,
    },
    link: 'https://api-docs.deepseek.com/quick_start/pricing',
  },

  'deepseek-v4-pro-thinking': {
    name: 'DeepSeek V4 Pro (Thinking)',
    description:
      'DeepSeek V4 Pro (now V4-Pro-0813 weights) with extended chain-of-thought reasoning enabled. Provider supports tool calling in thinking mode, but FFAI treats thinking variants as reasoning-only (no tools) to avoid mixed output.',
    strengths: [
      '1M token context window',
      'Extended chain-of-thought reasoning',
      'Most accurate DeepSeek model for analysis',
      'Superior performance on complex multi-step problems',
    ],
    limitations: [
      'No tool use in FFAI (provider supports it, but FFAI disables tools for thinking variants)',
      'Output tokens include reasoning tokens',
      'Higher cost than V4 Flash variants',
      'Not suitable for agent/tool workflows in FFAI',
    ],
    parameters: {
      contextWindow: 1048576,
      modelSize: 'MoE',
      maxTokens: 384000,
      trainingData: 'Up to 2026',
      modalities: ['text'],
      toolUse: false,
    },
    link: 'https://api-docs.deepseek.com/quick_start/pricing',
  },

  'deepseek-v4.1-flash': {
    name: 'DeepSeek V4.1 Flash',
    description:
      'Latest DeepSeek V4.1 Flash (Sep 10, 2026) with native visual understanding. Served via the API id `deepseek-flash`; shares V4 Flash pricing.',
    strengths: [
      'Native visual understanding (text + image input)',
      '1M token context window',
      'Fast inference at V4 Flash pricing',
      'Function calling + JSON output',
    ],
    limitations: [
      'Pricing depends on UTC peak/offpeak schedule',
      'Newer release — monitor for stability',
    ],
    parameters: {
      contextWindow: 1048576,
      modelSize: 'MoE',
      maxTokens: 384000,
      trainingData: 'Up to 2026',
      modalities: ['text', 'image'],
      toolUse: true,
    },
    link: 'https://api-docs.deepseek.com/updates/',
  },

  'grok-4.6': {
    name: 'xAI Grok 4.6',
    description:
      "xAI's most intelligent and fastest model — recommended for chat, coding, and agentic tool calling. Succeeds Grok 4.5 with the same 500K context and two-tier pricing.",
    strengths: [
      'Most intelligent and fastest xAI model',
      '500K context window with custom tool use',
      'Strong chat, coding, and agentic capabilities',
      '$2/$6 per MTok ($0.50 cached); ≥200K prompt: $4/$12 ($1 cached)',
      'OpenAI- and Anthropic-SDK compatible',
    ],
    limitations: [
      'Long-context tier doubles pricing above 200K prompt tokens',
      'Knowledge cutoff February 2026',
    ],
    parameters: {
      contextWindow: 500_000,
      modelSize: '',
      maxTokens: null,
      trainingData: 'February 2026',
      modalities: ['text', 'image'],
      toolUse: true,
    },
    link: 'https://docs.x.ai/developers/models/grok-4.6',
    legacy: true,
  },
  'grok-4.7': {
    name: 'xAI Grok 4.7',
    description:
      "xAI's newest flagship (Sep 21, 2026) — stronger coding, longer task execution, and better self-checking and context management.",
    strengths: [
      'Stronger coding capabilities',
      'Longer task execution',
      'Better self-checking and context management',
      '500K context window',
      '$2/$6 per MTok (faster variant 2×)',
    ],
    limitations: [
      'Faster variant costs twice as much',
      'Knowledge cutoff not disclosed',
    ],
    parameters: {
      contextWindow: 500_000,
      modelSize: '',
      maxTokens: null,
      trainingData: 'Not disclosed',
      modalities: ['text', 'image'],
      toolUse: true,
    },
    link: 'https://x.ai/news/grok-4-7',
  },
  'grok-4.5': {
    name: 'xAI Grok 4.5',
    description:
      "xAI's newest flagship (public API launch July 8, 2026) built on the 1.5T V9 foundation with Cursor training data — targets frontier coding, agentic tool calling, and knowledge work.",
    strengths: [
      'Best xAI model for code, agentic tool calling, and knowledge work',
      '500K context window',
      'Configurable reasoning effort (low/medium/high)',
      'OpenAI- and Anthropic-SDK compatible',
      'Cost-competitive: $2 input / $6 output per MTok',
    ],
    limitations: [
      'Not available in the EU at launch',
      'Slower throughput (~80 tok/s) than smaller Grok variants',
    ],
    parameters: {
      contextWindow: 500_000,
      modelSize: '1.5T',
      maxTokens: 8192,
      trainingData: 'June 2026',
      modalities: ['text', 'image'],
      toolUse: true,
    },
    link: 'https://x.ai/news/grok-4-5',
    legacy: true,
  },
  'grok-4.3': {
    name: 'xAI Grok 4.3',
    description:
      "xAI's workhorse model — 1M-token context at half the price of Grok 4.5. Strong balance of intelligence and cost for everyday coding and chat tasks.",
    strengths: [
      '1M-token context window (double Grok 4.5)',
      '$1.25/$2.50 per MTok — half the price of 4.5',
      'Strong everyday coding and agentic tool use',
      'OpenAI- and Anthropic-SDK compatible',
    ],
    limitations: [
      'Less capable than Grok 4.5 on frontier benchmarks',
      'Slower throughput than 4.20 variants',
    ],
    parameters: {
      contextWindow: 1_000_000,
      modelSize: '',
      maxTokens: 8192,
      trainingData: 'January 2026',
      modalities: ['text', 'image'],
      toolUse: true,
    },
    link: 'https://docs.x.ai/developers/models',
    legacy: true,
  },
  'grok-4.20-0309-reasoning': {
    name: 'xAI Grok-4.20 (Reasoning)',
    description:
      'Latest xAI flagship with extended reasoning and 2M context window.',
    strengths: [
      '2M token context window',
      'Advanced reasoning with thinking tokens',
      'Multi-agent orchestration support',
      'Best-in-class tool-calling',
      'X platform real-time data access',
    ],
    limitations: [
      'Higher latency due to reasoning',
      'Premium pricing',
      'X ecosystem exclusivity',
    ],
    parameters: {
      contextWindow: 2000000,
      modelSize: '',
      maxTokens: 8192,
      trainingData: 'March 2026',
      modalities: ['text', 'image'],
      toolUse: true,
    },
    link: 'https://docs.x.ai/developers/models',
  },
  'grok-4.20-0309-non-reasoning': {
    name: 'xAI Grok-4.20 (Non-Reasoning)',
    description:
      'Latest xAI flagship for fast responses without thinking tokens — 2M context window.',
    strengths: [
      '2M token context window',
      'Fast inference without thinking overhead',
      'Advanced tool-calling and agentic capabilities',
      'Cost-effective for high-throughput tasks',
    ],
    limitations: [
      'No extended reasoning capability',
      'May sacrifice depth for speed',
      'X ecosystem exclusivity',
    ],
    parameters: {
      contextWindow: 2000000,
      modelSize: '',
      maxTokens: 8192,
      trainingData: 'March 2026',
      modalities: ['text', 'image'],
      toolUse: true,
    },
    link: 'https://docs.x.ai/developers/models',
  },
  'grok-4.20-multi-agent-0309': {
    name: 'xAI Grok-4.20 Multi-Agent',
    description:
      'Specialized Grok-4.20 variant optimized for multi-agent orchestration and coordination tasks.',
    strengths: [
      '2M token context window',
      'Built for multi-agent coordination',
      'Advanced tool orchestration',
      'Parallel task management',
    ],
    limitations: [
      'Specialized use case (less general-purpose)',
      'Premium pricing',
      'X ecosystem exclusivity',
    ],
    parameters: {
      contextWindow: 2000000,
      modelSize: '',
      maxTokens: 8192,
      trainingData: 'March 2026',
      modalities: ['text', 'image'],
      toolUse: true,
    },
    link: 'https://docs.x.ai/developers/models',
  },
  'grok-code-fast-1': {
    name: 'xAI Grok Code Fast',
    description:
      'Speedy and economical reasoning model optimized for agentic coding tasks.',
    strengths: [
      'Optimized for agentic coding workflows',
      '256K token context window',
      'Fast inference with reasoning',
      'Economical pricing for coding tasks',
      'Strong code generation and analysis',
    ],
    limitations: [
      'Coding-focused (less general-purpose)',
      'Smaller context than Grok 4.20',
      'X ecosystem exclusivity',
    ],
    parameters: {
      contextWindow: 256000,
      modelSize: '',
      maxTokens: 8192,
      trainingData: 'November 2025',
      modalities: ['text'],
      toolUse: true,
    },
    link: 'https://docs.x.ai/developers/models',
    legacy: true,
  },
  'grok-4-1-fast-reasoning': {
    name: 'xAI Grok-4.1 Fast (Reasoning)',
    description:
      'Optimized tool-calling model with 2M context window, reasoning mode for complex agentic tasks',
    strengths: [
      '2M token context window',
      'Advanced reasoning with thinking tokens',
      'Best-in-class tool-calling capabilities',
      'Agent Tools API support (X search, file retrieval, Python execution, MCP servers)',
      '#1 on LMArena for agentic tasks',
      '50% reduction in hallucinations vs Grok 4 Fast',
    ],
    limitations: [
      'Higher latency due to reasoning',
      'Premium pricing',
      'X ecosystem exclusivity',
    ],
    parameters: {
      contextWindow: 2000000,
      modelSize: '',
      maxTokens: 8192,
      trainingData: 'November 2025',
      modalities: ['text', 'image'],
      toolUse: true,
    },
    link: 'https://x.ai/news/grok-4-1-fast',
    legacy: true,
  },
  'grok-4-1-fast-non-reasoning': {
    name: 'xAI Grok-4.1 Fast (Non-Reasoning)',
    description:
      'Ultra-fast tool-calling model with 2M context window for immediate responses without thinking tokens',
    strengths: [
      '2M token context window',
      'Blazing-fast inference (no thinking tokens)',
      'Instant responses for quick queries',
      'Advanced tool-calling and agentic capabilities',
      'Agent Tools API support',
      'Cost-effective for high-throughput tasks',
    ],
    limitations: [
      'No extended reasoning capability',
      'May sacrifice depth for speed',
      'X ecosystem exclusivity',
    ],
    parameters: {
      contextWindow: 2000000,
      modelSize: '',
      maxTokens: 8192,
      trainingData: 'November 2025',
      modalities: ['text', 'image'],
      toolUse: true,
    },
    link: 'https://x.ai/news/grok-4-1-fast',
    legacy: true,
  },
  'grok-4-0709': {
    name: 'xAI Grok-4',
    description:
      'Previous flagship model, offering unparalleled performance in natural language, math and reasoning',
    strengths: [
      'Deep Math knowledge',
      'Uses reasoning',
      'Deep Science knowledge',
      'Support structured output',
      'X platform integration',
    ],
    limitations: [
      'X ecosystem exclusivity',
      'Superseded by Grok 4.20',
      'Undisclosed architecture details',
    ],
    parameters: {
      contextWindow: 256000,
      modelSize: '',
      maxTokens: null,
      trainingData: 'July 9, 2025',
      modalities: ['text', 'image'],
      toolUse: true,
    },
    link: 'https://docs.x.ai/docs/models/grok-4-0709',
    legacy: true,
  },
  'grok-3-latest': {
    name: 'xAI Grok-3',
    description:
      'Previous flagship model that excels at enterprise use cases like data extraction, coding, and text summarization',
    strengths: [
      'Deep Science knowledge',
      'Deep Finance knowledge',
      'Deep Law knowledge',
      'Deep healthcare knowledge',
      'X platform integration',
    ],
    limitations: [
      'X ecosystem exclusivity',
      'Superseded by Grok 4.1',
      'Unpredictable alignment quirks',
      'Undisclosed architecture details',
      'Verbose citation outputs',
    ],
    parameters: {
      contextWindow: 131072,
      modelSize: '',
      maxTokens: null,
      trainingData: 'November 17, 2024',
      modalities: ['text', 'image'],
      toolUse: true,
    },
    link: 'https://docs.x.ai/docs/models/grok-3',
    legacy: true,
  },
  'grok-3-mini-latest': {
    name: 'xAI Grok-3 Mini',
    description: 'Previous lightweight model that thinks before responding.',
    strengths: [
      'Fast and Smart',
      'Great for logic based tasks',
      'Witty response style',
      'X platform integration',
    ],
    limitations: [
      'Does not have deep domain knowledge',
      'Superseded by Grok 4.1 Fast',
      'Unpredictable alignment quirks',
      'Undisclosed architecture details',
      'Verbose citation outputs',
    ],
    parameters: {
      contextWindow: 131072,
      modelSize: '',
      maxTokens: null,
      trainingData: 'November 17, 2024',
      modalities: ['text', 'image'],
      toolUse: true,
    },
    link: 'https://docs.x.ai/docs/models/grok-3-mini',
    legacy: true,
  },
  /* grok-2-latest not available via xAI API — 404 error, use grok-3 instead */
  'qwen/qwen3-32b': {
    name: 'Qwen 3 32B (via Groq)',
    description:
      'Dense 32.8B parameter model by Alibaba Cloud, optimized for reasoning and dialogue, served via Groq. Being deprecated by Groq on July 17, 2026 — migrate to Qwen 3.6 27B or GPT-OSS 120B.',
    strengths: [
      'Strong reasoning and coding capabilities',
      'Multilingual support (100+ languages)',
      '131k context window',
      'Fast inference via Groq LPU',
    ],
    limitations: [
      'Scheduled for Groq deprecation on Jul 17, 2026',
      'Smaller than 72B flagship models',
      'Knowledge cutoff constraints apply',
    ],
    parameters: {
      contextWindow: 131_072,
      modelSize: '32.8B',
      maxTokens: 8192,
      trainingData: 'Up to 2024',
      modalities: ['text'],
      toolUse: true,
    },
    link: 'https://groq.com/models/qwen-3-32b',
    legacy: true,
  },
  /* moonshotai/kimi-k2-instruct-0905 deprecated on Groq March 23, 2026 */
  'qwen/qwen3.6-27b': {
    name: 'Qwen 3.6 27B (via Groq)',
    description:
      'Dense 27B multimodal model from Alibaba — text, image, and video inputs with a 262K context. Strong on agentic coding, repo-level code understanding, and multi-step reasoning. Recommended Groq replacement for LLaMA 3.3 70B and Qwen 3 32B.',
    strengths: [
      'Multimodal: text, image, and video inputs',
      '262K context window with matching output capacity',
      'Strong agentic coding and repo-level reasoning',
      'Hybrid architecture with reasoning capabilities',
      'Fast inference via Groq LPU',
    ],
    limitations: [
      'Currently in Groq preview tier (not GA)',
      'Smaller than 32B/72B flagship models',
    ],
    parameters: {
      contextWindow: 262_144,
      modelSize: '27B',
      maxTokens: 16_384,
      trainingData: 'Up to early 2026',
      modalities: ['text', 'image', 'video'],
      toolUse: true,
    },
    link: 'https://console.groq.com/docs/models',
  },
};
